import React from 'react';
import { connect } from 'react-redux';
import Txt from '../../../inputs/textInput.js';
import Lbl from '../../../inputs/label.js';
import objectAssign from 'object-assign';
import { updateMeetingRoomForm } from '../../../../actions/meetingRoom.js';
import { ValidMe } from '../../../../businessLogic/validation.js';

@connect()
export default class CenterPanelUpdate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      groups: props.groups,
      meetingRoomForm: props.meetingRoomForm,
    };
    this.meetingRoomNameChanged = this.meetingRoomNameChanged.bind(this);
    this.meetingRoomUpdated = this.meetingRoomUpdated.bind(this);
  }

  meetingRoomUpdated(property, value) {
    let updatedMeetingRoomForm = objectAssign({}, this.state.meetingRoomForm, {
      [property]: value,
    });
    return updatedMeetingRoomForm;
  }

  meetingRoomNameChanged(value) {
    this.props.dispatch(updateMeetingRoomForm(this.meetingRoomUpdated('name', value)));
  }
  UNSAFE_componentWillReceiveProps(props) {
    //THIS EVENT TRIGGERS WHEN THE PARENT UPDATES DATA
    this.setState({
      groups: props.groups,
      meetingRoomForm: props.meetingRoomForm,
    });
  }
  render() {
    return (
      <div className="ui form">
        <ValidMe
          validmefor="length@3-64"
          validmemessage={APP.LANGUAGE.Errors.MeetingRoomValidNameLength}
          group="updateMeetingRoomForm"
        >
          <Txt
            focusme="true"
            tabIndex="1"
            fieldClasses="mrblll"
            noTitle
            value={this.state.meetingRoomForm.name}
            onChange={this.meetingRoomNameChanged}
            placeholder={APP.LANGUAGE.CreateUpdateMeetingRoom.NamePlaceholder}
          />
        </ValidMe>
      </div>
    );
  }
}

//  <button type="button"  className="max-width ui icon button  left"><i className="refresh icon"></i> { APP.LANGUAGE.CreateUpdateMeetingRoom.ResetRoomLink} </button>
//         <div className="mrtxs span-like  label"> {this.state.meetingRoomForm.meetingRoomLastResetCodeDate} </div>
